import { orderBy, groupBy, find, get, filter, size } from 'lodash';

export class AuditDataService {
    static sortOrdersByCreatedAt(data, direction = 'asc') {
        return orderBy(data, ['createdAt'], [direction]);
    }

    static groupOrdersBySalesChannel(data) {
        return groupBy(data, 'salesChannel.name');
    }

    static sortItemsByFirstAudit(data) {
        return orderBy(data, (item) => {
            // Si es un grupo bipicking, busca en la orden primaria
            // if (item.type === 'bipicking-group') {
            if (item.type === 'bipicking-group') {
                const primaryOrder = item.primaryOrder;
                const stats = get(primaryOrder, 'assignInfo.pickingTime.stats', []);
                const { audit = [] } = groupBy(stats, 'field');
                const firstAudit = find(audit, ({ correlative }) => correlative === 1);
                return new Date(get(firstAudit, 'init', 0)).getTime();
            }

            // Lógica original para órdenes normales
            const { audit = [] } = groupBy(get(item, 'assignInfo.pickingTime.stats', []), 'field');
            const firstAudit = find(audit, ({ correlative }) => correlative === 1);
            return new Date(get(firstAudit, 'init', 0)).getTime();
        }, ['asc']);
    }

    static groupBipickingOrders(data) {
        const bipickingOrders = filter(data, order => (size(get(order, 'assignInfo.ordersBipicking', [])) > 1));
        const normalOrders = filter(data, order => !(size(get(order, 'assignInfo.ordersBipicking', [])) > 1));

        // Agrupar órdenes bipicking por su relación
        const bipickingGroups = [];
        const processedIds = new Set();
        
        bipickingOrders.forEach(order => {
            const orderId = get(order, 'id');
            const relatedIds = get(order, 'assignInfo.ordersBipicking', []);
            
            if (!processedIds.has(orderId)) {
                // Buscar la orden relacionada
                const relatedOrder = bipickingOrders.find(o => 
                    relatedIds.includes(get(o, 'id')) && get(o, 'id') !== orderId
                );
                
                if (relatedOrder) {
                    // Crear grupo bipicking
                    bipickingGroups.push({
                        type: 'bipicking-group',
                        id: `${orderId}-${get(relatedOrder, 'id')}`,
                        orders: [order, relatedOrder],
                        primaryOrder: order,
                        secondaryOrder: relatedOrder,
                    });
                    
                    // Marcar ambas órdenes como procesadas para evitar duplicar grupos
                    processedIds.add(orderId);
                    processedIds.add(get(relatedOrder, 'id'));
                }
            }
        });
        
        // Incluir todas las órdenes bipicking individualmente además de los grupos
        // const allBipickingIndividual = bipickingOrders.map(order => ({
        //     ...order,
        //     type: 'individual-bipicking'
        // }));

        // Sólo incluir órdenes individuales que NO estén en grupos
        const nonGroupedBipickingOrders = bipickingOrders.filter(order => 
            !processedIds.has(get(order, 'id'))
        ).map(order => ({
            ...order,
            type: 'individual-bipicking'
        }));
        
        return {
            normalOrders,
            bipickingGroups,
            bipickingIndividual: bipickingOrders.map(order => ({
                ...order,
                type: 'individual-bipicking'
            })),
            allItems: [...normalOrders, ...bipickingGroups, ...nonGroupedBipickingOrders]
        };
    }

    static processDataWithBipicking(rawData) {
        if (!rawData || !Array.isArray(rawData)) {
            return {
                groupedData: {},
                totalCount: 0,
                hasData: false
            };
        }

        const orderedData = this.sortOrdersByCreatedAt(rawData);
        const groupedBySalesChannel = this.groupOrdersBySalesChannel(orderedData);
        
        // Procesar cada grupo para manejar bipicking
        const processedGroupedData = {};
        Object.keys(groupedBySalesChannel).forEach(salesChannelName => {
            const channelOrders = groupedBySalesChannel[salesChannelName];
            const { allItems } = this.groupBipickingOrders(channelOrders);
            processedGroupedData[salesChannelName] = this.sortItemsByFirstAudit(allItems);
        });

        return {
            groupedData: processedGroupedData,
            totalCount: rawData.length,
            hasData: Object.keys(processedGroupedData).length > 0
        };
    }
}